import axios from 'axios';
import Vue from 'vue'

export default {

    getCountries () {
        return axios.get('/api/countries/list')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCities (countryId) {
        return axios.get('/api/countries/cities', { params: { countryId: countryId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTowns (cityId) {
        return axios.get('/api/countries/towns', { params: { cityId: cityId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getLocalities (townId) {
        return axios.get('/api/countries/locality', { params: { townId: townId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getCurrentCustomerCities () {
        return axios.get('/api/countries/customer/cities')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
}

